import _ from "lodash";
export default (state: tcpinpoint.Document[] = [], action: any) => {
	switch (action.type) {
		case "GET_DOCUMENT_SUCCESS":
			return _.unionBy([action.resource], state, "id");
		case "GET_DOCUMENTS_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Document[], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
